var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"misc-inner p-2 p-sm-3"},[_c('div',{staticClass:"w-100 text-center"},[_c('h3',{staticClass:"mb-5"},[_vm._v(" شما به این بخش دسترسی ندارید! ")]),_c('b-img',{attrs:{"fluid":"","src":_vm.imgUrl}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }